
import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import Home from "./Pages/Home";
import Comunicados from "./Pages/Comunicados";
import GrupoForm from "./Pages/Grupos/novo";
import Grupos from "./Pages/Grupos";
import PrivateRoute from "./PrivateRoute";
import NovoComunicados from "./Pages/Comunicados/novo";
import DetalheComunicado from "./Pages/Comunicados/detalhe";
import MenuConfig from "./Pages/MenuConfig";


function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/comunicados" element={<PrivateRoute><Comunicados /></PrivateRoute>} />
      <Route path="/comunicados/novo" element={<PrivateRoute><NovoComunicados /></PrivateRoute>} />
      <Route path="/comunicados/:id" element={<PrivateRoute><DetalheComunicado /></PrivateRoute>} />
      <Route path="/grupos/novo" element={<PrivateRoute><GrupoForm /></PrivateRoute>} />
      <Route path="/grupos" element={<PrivateRoute><Grupos /></PrivateRoute>} />
      <Route path="/grupos/:id" element={<PrivateRoute><GrupoForm /></PrivateRoute>} />
      <Route path="/menu-config" element={<PrivateRoute><MenuConfig /></PrivateRoute>} />
    </Routes>
  );
}

export default App;
